module.exports = "/virtual-football-league/img/vdh-progress.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/vdh-progress.png
// module id = 332
// module chunks = 4